export enum ContentReferenceType {
    Movie = 1,
    TvSeries = 2,
    Ancillary = 3
}
